import { gql } from '@apollo/client';

/** DSP 生成 Invoice；invoiceNo 由 DSP 填写 */
export const GENERATE_MY_DSP_INVOICE = gql`
    mutation GenerateMyDspInvoice($billId: ID!, $invoiceNo: String!, $clientTimezone: String) {
        generateMyDspInvoice(billId: $billId, invoiceNo: $invoiceNo, clientTimezone: $clientTimezone) {
            invoiceId
            invoiceNo
            status
            submitted
            invoiceAmount
            currency
            pdfPreviewUrl
            pdfDownloadUrl
        }
    }
`;

/** DSP 重新生成 Invoice（作废旧的并重建），仅财务确认前可用 */
export const REGENERATE_MY_DSP_INVOICE = gql`
    mutation RegenerateMyDspInvoice($billId: ID!, $invoiceNo: String!, $clientTimezone: String) {
        regenerateMyDspInvoice(billId: $billId, invoiceNo: $invoiceNo, clientTimezone: $clientTimezone) {
            invoiceId
            invoiceNo
            status
            submitted
            invoiceAmount
            currency
            pdfPreviewUrl
            pdfDownloadUrl
        }
    }
`;

/** DSP 提交 Invoice 给财务审核 */
export const SUBMIT_MY_DSP_INVOICE = gql`
    mutation SubmitMyDspInvoice($billId: ID!) {
        submitMyDspInvoice(billId: $billId)
    }
`;

/** DSP 在财务确认前撤回已提交的 Invoice；只撤回提交，Invoice 不作废 */
export const WITHDRAW_MY_DSP_INVOICE_SUBMIT = gql`
    mutation WithdrawMyDspInvoiceSubmit($billId: ID!) {
        withdrawMyDspInvoiceSubmit(billId: $billId)
    }
`;

/**
 * 上传自制 Invoice 原件并解析。文件以 Base64 传入由后端落 S3（**不走前端直传 S3**），
 * 与 submitQcPenaltyUpload 等既有上传接口一致。
 * 此步不落库 Invoice，解析结果仅用于预填表单。
 */
export const UPLOAD_MY_SELF_MADE_DSP_INVOICE = gql`
    mutation UploadMySelfMadeDspInvoice($billId: ID!, $fileBase64: String!, $fileName: String!) {
        uploadMySelfMadeDspInvoice(billId: $billId, fileBase64: $fileBase64, fileName: $fileName) {
            objectKey
            fileName
            parsed
            invoiceNo
            totalAmountDue
            failReason
        }
    }
`;

/**
 * DSP 确认并落库自制 Invoice。
 * 原件与解析结果来自 UPLOAD_MY_SELF_MADE_DSP_INVOICE，invoiceNo 与 totalAmountDue
 * 取页面确认后的值（解析失败时即为手填值）。
 */
export const CONFIRM_MY_SELF_MADE_DSP_INVOICE = gql`
    mutation ConfirmMySelfMadeDspInvoice(
        $billId: ID!
        $objectKey: String!
        $fileName: String!
        $invoiceNo: String!
        $totalAmountDue: Long!
        $parseFailed: Boolean!
        $clientTimezone: String
    ) {
        confirmMySelfMadeDspInvoice(
            billId: $billId
            objectKey: $objectKey
            fileName: $fileName
            invoiceNo: $invoiceNo
            totalAmountDue: $totalAmountDue
            parseFailed: $parseFailed
            clientTimezone: $clientTimezone
        ) {
            invoiceId
            invoiceNo
            status
            submitted
            invoiceAmount
            currency
            isSelfMade
            isParseFailed
            pdfPreviewUrl
            pdfDownloadUrl
        }
    }
`;
